import { createStore, combineReducers      } from 'redux';
import { defaultMiddleware                 } from 'alto-utils/lib/store';
import { CANTEEN_NAMESPACE, canteenReducer } from 'alto-react-canteen/lib/store';

const rootReducer = combineReducers({ [CANTEEN_NAMESPACE]: canteenReducer });

export default createStore(rootReducer, undefined, defaultMiddleware);
